export { default as Triangle, triangleVariants } from './Triangle.component'
